import React, { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { CardView } from 'design-system/CardView';
import { rem } from 'design-system/values';
import Section from 'design-system/Section';
import SubscriptionAd from 'features/subscriptions/components/transactions/SubscriptionAd';
import Amplitude from 'utils/amplitude';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import TransactionHelpItem from './TransactionHelpItem';
import { styles as sectionStyles } from './styles';
import { isWeb } from '../../../../constants';
const TransactionHelpSection = ({ transaction }) => {
    const nav = useMainStackNavigation();
    const openAd = (routeWithParams) => {
        nav.navigateDeprecated(routeWithParams);
        Amplitude.logEvent('Item.openCompare', { type: routeWithParams.name });
    };
    const openContactSupport = useCallback(() => {
        nav.navigate('Help', {
            articlesKey: HELP_ARTICLES_KEY.TRANSACTIONS_HELP,
        });
    }, [nav]);
    const openSupport = () => {
        Links.openLink('https://help.emma-app.com/en/category/transactions-and-categories-1bw1563/');
    };
    return (<Section title="Help" style={sectionStyles.section}>
      <CardView noMarginTop noMarginBottom>
        {!isWeb && !transaction?.isPending && transaction.merchant ? (<SubscriptionAd merchant={transaction.merchant} onPress={openAd} style={styles.adContainer}/>) : null}
        <TransactionHelpItem title="Need to amend your data?" subTitle="Learn how to" onPress={openSupport}/>
        <TransactionHelpItem title="Something not right?" subTitle="View help options" onPress={openContactSupport}/>
      </CardView>
    </Section>);
};
const styles = StyleSheet.create({
    adContainer: {
        marginTop: rem(16),
    },
});
export default memo(TransactionHelpSection);
